/**
 * Sort by priority
 *
 * @param {Object} a
 * The first object to compare
 *
 * @param {Object} b
 * The second object to compare
 */
const comparePriority = (a: any, b: any) => {
  if (!(b.priority >= 0) || a.priority < b.priority) {
    return -1
  }
  if (!(a.priority >= 0) || a.priority > b.priority) {
    return 1
  }
  return 0
}

/**
 * Insert an array item at a specific index
 *
 * @param {Array} arr
 * The array to insert into
 *
 * @param {Number} i
 * The index to insert at
 *
 * @param item
 * The item to insert
 */
const insertAt = (arr: any, i: number, item: any) => {
  const newArr = [...arr]
  newArr[i] = item
  return newArr
}

/**
 * Make into an array if it isn't already
 *
 * @param {String | Array} val
 * The value to return or add to array
 */
const makeArr = (val: any): any[] => (Array.isArray(val) ? val : [val])

/**
 * Capitalise the first letter of a strinig
 *
 * @param {Strinig} val
 * The string to capitalise
 */
const capitalise = (val: string) => val.charAt(0).toUpperCase() + val.slice(1)

/**
 * Generate a random string
 */
const getRandomString = (bytes: number) => {
  const randomValues = new Uint8Array(bytes)
  window.crypto.getRandomValues(randomValues)

  return Array.from(randomValues)
    .map((nr: number) => nr.toString(16).padStart(2, '0'))
    .join('')
}

/*
 * Take the current path (e.g. /submission or /nestingslug/submission
 * replace with the new path
 * e.g. /submission/thankyou or /nestingslug/submission/thankyou
 */
const relative_replace = (originalPath: string, path: string) => {
  if (!originalPath) return path
  if (!path) return ''
  const pathSplit = path.split('/')
  const originalSplit = originalPath.split('/')

  const newFirst = pathSplit[0] || pathSplit[1]
  if (!newFirst) return path

  const newIndex = originalSplit.indexOf(newFirst)
  //Not necessary but clearer
  //because: splice(0, -1) = []
  if (newIndex === -1) return path

  const parts = [...originalSplit.splice(0, newIndex), ...pathSplit].filter((x) => x.length > 0)

  return '/' + parts.join('/')
}

const removeDuplicatesFromArrayWithSameKey = (arrayToDedupe: any[], field: string): any[] => {
  return arrayToDedupe.filter((value, index, a) => {
    if (value[field] === undefined) return true
    const foundIndex = a.findIndex((item) => item[field] === value[field])
    return foundIndex === index
  })
}

const validateUUID = (uuid: string) => {
  if (uuid) {
    const length = uuid.trim().length
    switch (length) {
      case 9:
        return /^(\s+|)[a-z0-9]{8}-$/.test(uuid)
      case 14:
        return /^(\s+|)[a-z0-9]{8}-[a-z0-9]{4}-$/.test(uuid)
      case 19:
        return /^(\s+|)[a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-$/.test(uuid)
      case 24:
        return /^(\s+|)[a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-$/.test(uuid)
    }

    if (length >= 36) {
      return /^(\s+|)[a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12}(\s+|)$/i.test(uuid)
    }

    return false
  }
  return false
}

export const parseSignature = (signature: string) => {
  // length of uuid = 36
  // length of token = 20
  const decoded = Buffer.from(signature, 'base64').toString()
  const claimId = decoded.slice(0, 36)
  const token = decoded.slice(36)

  if (!validateUUID(claimId)) {
    return null
  }

  if (token.length !== 20) {
    return null
  }

  return [claimId, token]
}

export {
  comparePriority,
  insertAt,
  makeArr,
  capitalise,
  getRandomString,
  relative_replace,
  removeDuplicatesFromArrayWithSameKey,
  validateUUID,
}
